<template>
  <div class="main" :style="{ backgroundColor: info.bgColor }">
    <div class="bgimg">
      <img :src="info.asUrl" alt="" style="height: 100%; width: 100%" />
    </div>
    <div class="content">
      <ul class="list">
        <van-list v-model="loading" :finished="finished" @load="onLoad">
          <li
            v-for="(item, i) in list"
            :key="i"
            class="card isTrue"
            :class="
              item.totalCount > item.useCount && !item.isOk
                ? 'isTrue'
                : item.totalCount == item.useCount
                ? 'isFalse'
                : 'bgf'
            "
          >
            <div class="left" v-if="item.type == 1">
              <p>
                ￥<span
                  style="font-size: 0.64rem; line-height: 0.78rem"
                  class="faDINCondensedC"
                  >{{ item.frReductionMoney }}</span
                >
              </p>
              <p>满{{ item.frFullMoney }}可用</p>
            </div>
            <div class="left" v-if="item.type == 2">
              <p>
                ￥<span
                  style="font-size: 0.64rem; line-height: 0.78rem"
                  class="faDINCondensedC"
                  >{{ item.sdMoney }}</span
                >
              </p>
              <p>无门槛</p>
            </div>
            <div class="left" v-if="item.type == 3">
              <p>
                <span
                  style="font-size: 0.64rem; line-height: 0.78rem"
                  class="faDINCondensedC"
                  >{{ item.discount }}</span
                >折
              </p>
              <p>抵扣上限{{ item.discountUp }}</p>
            </div>
            <div class="right">
              <p>{{ item.title | ellipsis }}</p>

              <p v-if="item.expiryStartDate" style="font-size: 0.2rem">
                {{ item.expiryStartDate }}-{{ item.expiryEndDate }}
              </p>
            </div>
            <div
              class="btn bg1"
              v-if="item.totalCount > item.useCount && !item.isOk"
              @click="goProductInfo(item, i)"
            >
              领 取
            </div>
            <div class="btn bg3" v-else-if="item.isOk && item.linkType == 0">
              已领取
            </div>
            <div
              class="btn bg3"
              v-else-if="item.isOk && item.linkType == 1"
              @click="golink(item)"
            >
              去使用
            </div>
          </li>
        </van-list>
      </ul>

      <div class="title colorfff">
        <img src="../assets/icon5.png" alt="" /><span>活动规则</span
        ><img src="../assets/icon6.png" alt="" />
      </div>
      <div class="Text_description fs28">
        <p class="colorfff">一、活动时间：</p>
        <p class="colorfff">{{ info.startDate }}-{{ info.endDate }}</p>
        <p class="colorfff" style="padding-top: 0.2rem">二、参与条件：</p>
        <p class="colorfff" style="white-space: pre-line">
          {{ info.desp }}
        </p>
      </div>
    </div>
    <div class="ipone" v-show="show">
      <div class="ipone_content">
        <p>身份认证</p>
        <p>
          为保证支付安全，请输入手机号进行身份验证，手机号也是您的服务凭证，请按实际情况填写
        </p>
        <div class="iponeIpt Ipt">
          <input
            type="tel"
            v-model="phone"
            placeholder="请输入手机号"
            maxlength="11"
            @blur="blur()"
          />
        </div>
        <div class="iponeCode Ipt">
          <input
            type="tel"
            maxlength="6"
            v-model="code"
            placeholder="请输入验证码"
            @blur="blur()"
          />
          <div></div>
          <span
            @click="getCode()"
            :style="isCodeTime == 0 ? 'color:#F44336' : 'color:#999999'"
            >{{ text }}</span
          >
        </div>
        <p class="warn">{{ warntext }}</p>
        <button class="OkBtn" @click="OkClick">确定</button>
        <p class="CloseBtn" @click="CloseClick">关闭窗口</p>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/mall";
import { Toast, List } from "vant";
import "../css/font.css";
import Vue from "vue";
import { mobile_rule } from "@/utils/num";
import {
  connectWebViewJavascriptBridge,
  getBrowserUserAgent,
} from "@/utils/utility";
export default {
  components: {
    [Toast.name]: Toast,
    [List.name]: List,
  },
  data() {
    return {
      list: [],
      activityId: "",
      info: {},
      show: false,
      isLoading: false,
      loading: false,
      finished: true,
      total: 0,
      phone: "",
      text: "获取验证码",
      warntext: "",
      YouRui: false,
      code: "",
      isCodeTime: 0,
      page: 1,
      current: 0,
    };
  },
  created() {
    this.activityId = this.$route.query.activityId;
    this.getList();
    this.getinfo();
    this.YouRui = getBrowserUserAgent().YouRui;
  },
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 15) {
        return value.slice(0, 15) + "...";
      }
      return value;
    },
  },
  mounted() {
    var that = this;
    if (getBrowserUserAgent().android) {
      this.$bridge.registermethod("changeTheme", function (responseData) {
        responseData = JSON.parse(responseData);
        that.theme = responseData;
        sessionStorage.setItem("theme", responseData);
      });
    } else {
      connectWebViewJavascriptBridge((bridge) => {
        var that = this;
        window.WebViewJavascriptBridge.registerHandler(
          "changeTheme",
          function (responseData) {
            responseData = JSON.parse(responseData);
            that.theme = responseData;
            sessionStorage.setItem("theme", responseData);
          }
        );
      });
    }
  },
  methods: {
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        this.page++;

        // 加载状态结束
        // console.log(this.page);
        this.loading = false;
        this.getList();

        // 数据全部加载完成
      }, 1000);
    },
    getList() {
      api
        .getActivityDcList({
          activityId: this.activityId,
          page: this.page,
          pageSize: 20,
        })
        .then((res) => {
          if (res.code == 200) {
            this.total = res.data.total;
            this.current = res.data.current;
            var list = [];
            res.data.records.forEach((p) => {
              if (p.expiryEndDate) {
                p.expiryEndDate = p.expiryEndDate.replace(/-/g, ".");
              }
              if (p.expiryStartDate) {
                p.expiryStartDate = p.expiryStartDate.replace(/-/g, ".");
              }
              if (p.totalCount - p.useCount >= 0) {
                p.Count = 1;
              }

              if (p.limitCount === p.receiveCount) {
                p.isOk = true;
              }
              list.push(p);
            });
            console.log(list);
            if (this.page == 1) {
              this.list = [];
            }
            this.list = this.list.concat(list);
            if (this.list.length >= this.total || this.page >= this.current) {
              this.finished = true;
              this.title = "没有更多了";
            } else {
              this.finished = false;
              this.title = "";
            }
          }
        });
    },
    getinfo() {
      api.getActivityInfo({ activityId: this.activityId }).then((res) => {
        if (res.code == 200) {
          this.info = res.data;
        }
      });
    },
    golink(item) {
      window.location.href = item.link;
    },
    goProductInfo(item, i) {
      var token = sessionStorage.getItem("Access-Token");
      if (token) {
        let params = { activityId: this.activityId, dcId: item.id };
        api.getDiscountCouponReceive(params).then((res) => {
          if (res.code == 200) {
            Toast("领取成功");
            item.isOk = true;
            Vue.set(this.list, i, item);
          } else {
            Toast(res.message);
          }
        });
      } else {
        if (this.YouRui) {
          var that = this;
          if (getBrowserUserAgent().android) {
            that.$bridge.callmethod("gotoLogin", {}, function (responseData) {
              responseData = JSON.parse(responseData);
              // console.log(responseData);
              that.userId = responseData.userId;
              that.userToken = responseData.userToken;
              sessionStorage.setItem("userId", that.userId);
              sessionStorage.setItem("Access-Token", that.userToken);
              this.page = 1;
              that.getList();
              // getHeaderToken(myWebkey, myuserId)
            });
          } else {
            window.WebViewJavascriptBridge.callHandler(
              "gotoLogin",
              {},
              function (responseData) {
                responseData = JSON.parse(responseData);
                // console.log(responseData);
                that.userId = responseData.userId;
                that.userToken = responseData.userToken;
                sessionStorage.setItem("userId", that.userId);
                sessionStorage.setItem("Access-Token", that.userToken);
                this.page = 1;
                that.getList();
                // getHeaderToken(myWebkey, myuserId)
              }
            );
          }
        } else {
          this.show = true;
        }
      }

      // this.$router.push('/ProductInfo?id='+'')
    },
    blur() {
      setTimeout(function () {
        var scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },
    CloseClick() {
      this.show = false;
    },
    getCode() {
      const TIME_COUNT = 60;
      if (this.phone == "") {
        this.warntext = "手机号不能为空";
        return false;
      }
      if (!mobile_rule(this.phone)) {
        this.warntext = "手机号不正确";
        return false;
      }
      var params = {
        phone: this.phone,
      };

      api.getCode(params).then((res) => {
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.text = this.count + "s后可重发";
          //  this.show = false;
          this.isCodeTime = 1;
          this.timer = setInterval(() => {
            if (this.count > 1 && this.count <= TIME_COUNT) {
              this.count--;
              this.text = this.count + "s后可重发";
            } else {
              //  this.show = true;
              this.isCodeTime = 0;
              clearInterval(this.timer);
              this.text = "获取验证码";
              this.timer = null;
            }
          }, 1000);
        }
      });
    },
    OkClick() {
      var that = this;
      var params = {
        deviceType: "4",
        phone: that.phone,
        code: that.code,
        // registerSource: register_source,
      };
      // if (sessionStorage.getItem("openid")) {
      //   params.openid = sessionStorage.getItem("openid");
      // }
      api.getCodelogin(params).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          localStorage.setItem("token", res.data.token);
          sessionStorage.setItem("token", res.data.token);

          sessionStorage.setItem("Access-Token", res.data.token);
          that.show = false;
          clearInterval(that.timer);
        } else {
          that.warntext = res.message;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.faDINCondensedC {
  font-family: "DINCondensedC";
}
.main {
  min-height: 100vh;
  // background: #f85530 url(../assets/icon4.png) no-repeat;
  background-size: 100% 3.85rem;
  .content {
    position: relative;
    padding-top: 3.52rem;
    z-index: 1000;
  }
  .list {
    width: 6.88rem;
    background: #ffffff;
    border-radius: 0.2rem;
    padding: 0.3rem 0;
    margin-left: 0.3rem;
  }
}
.Text_description {
  padding: 0.3rem;
}
.title {
  padding: 0.3rem 0.3rem 0 0.3rem;
  display: flex;
  align-items: center;
  font-size: 0.34rem;
  font-weight: 500;
  justify-content: space-between;
  img {
    width: 2.63rem;
    height: 0.26rem;
  }
}
.isTrue {
  background: url(../assets/bj@fff.png) no-repeat;
  background-size: 100% 100%;
}
.isFalse {
  background: url(../assets/bj6253.png) no-repeat;
  background-size: 100% 100%;
}
.bgf {
  background: url(../assets/bj@2x22.png) no-repeat;
  background-size: 100% 100%;
  .left {
    color: #fa3b32 !important;
  }
}
.card {
  //   width: 6.88rem;
  height: 2.2rem;
  margin: 0 0.1rem 0.1rem 0.1rem;
  display: flex;
  align-items: center;
  .left {
    width: 1.75rem;
    height: 1.7rem;
    padding-top: 0.3rem;
    padding-left: 0.1rem;
    color: #fff;
    text-align: center;
    p:nth-child(2) {
      font-size: 0.26rem;
      line-height: 0.37rem;
    }
  }
  .right {
    width: 3.15rem;
    height: 2rem;
    margin-right: 0.11rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-shadow: 0px 0.02rem 0.11rem #f3f3fa;
    color: #5d667a;
    p:nth-child(1) {
      font-size: 0.38rem;
      font-weight: 500;
      padding-left: 0.3rem;
      line-height: 0.53rem;
    }
    p:nth-child(2) {
      font-size: 0.3rem;
      font-weight: 400;
      padding-left: 0.3rem;
      line-height: 0.42rem;
      padding-top: 0.04rem;
       color: #999;
    }
  }
}
.btn {
  width: 1.2rem;
  height: 0.6rem;
  background: #fa3b32;
  // box-shadow: 0px 0.02rem 0.11rem 0px #f3f3fa;
  border-radius: 0.3rem;
  border: 0.02rem solid #fa3b32;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 0.28rem;
  // text-shadow: 0px 0.02rem 0.11rem #f3f3fa;
}
.bgimg {
  position: absolute;
  top: 0;
  left: 0;
  height: 3.76rem;
  width: 100%;

  img {
  }
}
.bg3 {
  background: #ffffff;
  box-shadow: 0px 2px 11px 0px #f3f3fa;
  color: #fa3b32 !important;
  border: 0.02rem solid #fa3b32;
}

.ipone {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  .ipone_content {
    width: 5.3rem;
    height: 6.8rem;
    background: #ffffff;
    padding: 0.6rem;
    p:first-child {
      font-size: 0.36rem;
      font-weight: 500;
      color: #333333;
      text-align: center;
      line-height: 0.4rem;
      padding-bottom: 0.2rem;
    }
    p:nth-child(2) {
      font-size: 0.28rem;
      font-weight: 400;
      color: #666666;
      line-height: 0.4rem;
      padding-bottom: 0.48rem;
    }
    .iponeIpt {
      margin-bottom: 0.24rem;
      input {
        width: 100%;
        height: 100%;
        border: 0;
        text-align: center;
        font-size: 0.48rem;
      }
    }
    input::-webkit-input-placeholder {
      /* 修改字体颜色 */
      color: #999;
      /* 修改字号，默认继承input */
      font-size: 0.32rem;
      /* 设置背景色 */
      // background: #8ac6d1;
    }
    .iponeCode {
      display: flex;
      align-items: center;

      input {
        width: 49%;
        height: 100%;
        background: rgba(0, 0, 0, 0);
        border: 0;
        text-align: center;
        font-size: 0.4rem;
      }
      input:-webkit-autofill,
      textarea:-webkit-autofill,
      select:-webkit-autofill {
        -webkit-box-shadow: 0 0 0 1000px white inset;
        border: 1px solid #ccc !important;
      }
      div {
        width: 0.02rem;
        height: 0.4rem;
        background: rgba(102, 102, 102, 1);
      }
      span {
        width: 49%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #f44336;
      }
    }
    .Ipt {
      width: 5.3rem;
      height: 1rem;
      background: #ffffff;
      border-radius: 0.04rem;
      border: 1px solid #999999;
    }
    .warn {
      padding: 0.12rem 0 0.18rem 0;
      height: 0.3rem;
      font-size: 0.26rem;
      font-weight: 400;
      color: #f44336;
      line-height: 0.3rem;
    }
    .OkBtn {
      width: 100%;
      height: 1rem;
      background: #f44336;
      border-radius: 0.04rem;
      border: 0;
      color: #fff;
      font-size: 0.36rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .CloseBtn {
      padding-top: 0.24rem;
      font-size: 0.3rem;
      font-weight: 400;
      color: #999999;
      text-align: center;
    }
  }
}
</style>